<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="row" v-if="requests.id">
            <div class="col-lg-3 col-md-6">
              <div class="widget home style1">
                <div class="row">
                  <div class="col-4">
                    <div class="main-card__icon-container">
                      <i class="fas fa-truck-loading fa-2x"></i>
                    </div>
                  </div>
                  <div class="col-8 text-right">
                    <span>نوع بار</span>
                    <h1 class="font-bold main-card__data">
                      {{ requests.load_data ? requests.load_data.name : "-" }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="widget home style1">
                <div class="row">
                  <div class="col-4">
                    <div class="main-card__icon-container">
                      <i class="fas fa-truck-moving fa-2x"></i>
                    </div>
                  </div>
                  <div class="col-8 text-right">
                    <span>نوع ماشین</span>
                    <h2 class="font-bold main-card__data">
                      {{ requests.vehicle_type.name }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="widget home style1">
                <div class="row">
                  <div class="col-4">
                    <div class="main-card__icon-container">
                      <i class="fas fa-map-marked fa-2x"></i>
                    </div>
                  </div>
                  <div class="col-8 text-right">
                    <span>مبدا</span>
                    <h1 class="font-bold main-card__data">
                      {{ requests.origin.province.name }} /
                      {{ requests.origin.name }} /
                      {{ requests.loading_at | jalaliDateShort }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="widget home style1">
                <div class="row">
                  <div class="col-4">
                    <div class="main-card__icon-container">
                      <i class="fas fa-map-marked-alt fa-2x"></i>
                    </div>
                  </div>
                  <div class="col-8 text-right">
                    <span>مقصد</span>
                    <h1 class="font-bold main-card__data">
                      {{ requests.destination.province.name }} /
                      {{ requests.destination.name }} /
                      {{ requests.delivery_at | jalaliDateShort }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class=" align-items-center justify-content-md-start align-items-md-start w-100 justify-content-center justify-content-md-between py-3"
          >
            <div
              class="d-flex flex-column flex-md-row align-items-start align-items-md-center k-gap-2 justify-content-around"
            >
              <state-filter
                v-model="filter.state_id"
                :allowedStates="[1, 2, 3, 4, 5]"
              />
              <date-filter v-model="filter.date" />

              <div class="d-flex">
                <bita-filtersbutton
                  icon="fas fa-filter"
                  :title="filterTitle"
                  @click="toggleFilters"
                  class="my-1 md-my-0 "
                />
                <bita-filtersbutton
                  icon="fas fa-print"
                  title="چاپ"
                  class="h-100 my-1 md-my-0 mx-2"
                  @click="printRequestDetail"
                />
                <bita-filtersbutton
                  icon="fas fa-print"
                  title="چاپ خلاصه"
                  @click="printRequestDetailSummary"
                  class="my-1 md-my-0"
                />
                <bita-filtersbutton
                  v-if="$acl.can('view', 'importRequestExcel')"
                  icon="fas fa-file-upload"
                  title="ارسال اکسل"
                  @click="showGallery"
                  class="my-1 md-my-0 mx-2"
                />
              </div>
            </div>
          </div>
          <br />
          <input
            ref="inputExcelRef"
            type="file"
            v-show="false"
            @change="sendExcel"
          />
          <transition name="fade">
            <div v-show="showFilters">
              <bita-form ref="form">
                <div slot="body">
                  <div class="row">
                    <bita-select
                      ref="statesDropDown"
                      name="states"
                      label="وضعیت"
                      rules
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="states"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="filter.state_id"
                    />
                    <!-- <bita-select
                        ref="carrierDropDown"
                        name="carrier"
                        label="باربری"
                        rules
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="carriers"
                        data-text-field="name"
                        data-value-field="id"
                        v-model="filter.carrier_id"
                    /> -->
                    <bita-autocomplete
                      ref="driversDropDown"
                      name="drivers"
                      label="راننده"
                      data-text-field="name"
                      data-value-field="id"
                      rules="required"
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="drivers"
                      @filtering="filterDrivers"
                      v-model="filter.driver_id"
                      subtitle="جستجو بر اساس نام راننده می‌باشد"
                    />
                    <bita-input
                      type="text"
                      name="national_code"
                      label="کدملی راننده"
                      rules=""
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      v-model.lazy="filter.national_code"
                      @change="(e) => filterDrivers(e)"
                      subtitle="جستجو فقط با کد‌ملی کامل و صحیح"
                    />
                    <bita-input
                      type="text"
                      name="mobile"
                      label="شماره موبایل"
                      rules=""
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      v-model.lazy="filter.phone"
                      @change="(e) => filterDrivers(e)"
                    />
                    <bita-input
                      type="text"
                      name="car_smartnumber"
                      label="هوشمند ماشین"
                      rules=""
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      v-model.lazy="filter.car_smartnumber"
                      @change="(e) => driverSearch(e)"
                      subtitle="جستجو فقط با هوشمند ماشین کامل و صحیح"
                    />
                    <div>
                      <plate-number-inputes
                        ref="plate"
                        v-model="filter.number_plate"
                        @input="(e) => driverSearch(e)"
                      />
                    </div>
                    <!-- <bita-formbutton title="فیلتر" btnWidth="col-lg-1" @click="loadData" /> -->
                  </div>
                </div>
              </bita-form>
            </div>
          </transition>
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :hasRow="false"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
            :batch="true"
            :resizable="true"
            :on-data-binding="onDataBinding"
          />
        </div>
      </bita-ibox>
    </div>
    <form-modal
      modal-id="edit-modal"
      title="ویرایش"
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-data="updateForm"
      @on-submit="handleEdit"
    />

    <driver-info-modal
      ref="driverInfo"
      modal-id="driver-info-modal"
      :title="`اطلاعات راننده`"
      :is-loading="isLoadingModal"
    />

    <waybill-info-modal
      ref="waybillInfo"
      modal-id="waybill-info-modal"
      :title="`اطلاعات بارنامه`"
      :is-loading="isLoadingModal"
    />

    <assign-request-to-driver
      ref="assignRequestToDriver"
      modal-id="assign-request-to-driver-modal"
      :title="`تخصیص بار`"
      :is-loading="isLoadingModal"
      @get:requestDetails="loadData"
    />

    <!-- Actions -->
    <g-context-menu ref="contextMenu" #default="{items: requestDetail}">
      <g-list>
        <g-list-item
          title="جزئیات بار"
          icon="fas fa-info"
          @click="showDriverInfo(requestDetail)"
        />
        <g-list-item
          v-if="$acl.can('update', 'requestdetails')"
          title="ویرایش وضعیت بار"
          icon="fas fa-pen-square"
          @click="edit(requestDetail)"
        />
        <g-list-item
          v-if="requestDetail.state_id == 71"
          title="تخصیص بار"
          icon="fas fa-truck-loading"
          @click="showAssignRequestToDriverForm(requestDetail)"
        />
        <g-list-item
          v-if="$acl.isSuperAdmin"
          title="اطلاعات بارنامه"
          icon="fas fa-id-card"
          @click="waybillInfo(requestDetail)"
        />
        <g-list-item
          v-if="$acl.can('delete', 'requestdetails')"
          title="حذف"
          icon="fas fa-times"
          @click="deleteRequest(requestDetail)"
        />
      </g-list>
    </g-context-menu>
  </div>
</template>
<script>
import RequestDetailForm from "./Form";
import DateFilter from "./../../../components/DateFilter";
import StateFilter from "./../../../components/StateFilter";
import DriverInfoModal from "../../requests_managements/components/DriverInfoModal";
import WaybillInfoModal from "../../requests_managements/components/WaybillInfoModal";
import AssignRequestToDriver from "../../requests_managements/components/AssignRequestToDriver.vue";
import GContextMenu from "./../../../components/GContextMenu.vue";
import GList from "./../../../components/listItem/GList.vue";
import GListItem from "./../../../components/listItem/GListItem.vue";
import PlateNumberInputes from "@/components/PlateNumberInputs.vue";

export default {
  components: {
    PlateNumberInputes,
    "form-modal": RequestDetailForm,
    "date-filter": DateFilter,
    StateFilter,
    DriverInfoModal,
    WaybillInfoModal,
    AssignRequestToDriver,
    GContextMenu,
    GList,
    GListItem,
  },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "مدیریت سیستم", link: "" },
        { title: "مدیریت درخواست حمل", link: "/management/requests" },
        {
          title: `درخواست شماره ${this.$route.params.id}`,
          link: `/management/request-detail/${this.$route.params.id}`,
          active: true,
        },
      ],
      isLoadingModal: false,
      isLoadingGrid: false,
      showFilters: false,
      updateForm: {
        driver_id: 0,
      },
      filter: {},
      requests: {},
      drivers: [],
      customers: [],
      // carriers: [],
      gridColumns: [
        { title: "#", template: this.getTemplateID, width: "40px" },
        {
          field: "tracking_code",
          title: "کد",
          template: (e) => (e.tracking_code ? e.tracking_code : " - "),
          width: "100px",
        },
        // {
        //   field: "request.origin",
        //   title: "مبدا",
        //   template: (e) =>
        //     e.request && e.request.origin
        //       ? `${e.request.origin.province.name}/${e.request.origin.name}`
        //       : " - ",
        // },
        // {
        //   field: "request.destination",
        //   title: "مقصد",
        //   template: (e) =>
        //     e.request && e.request.destination
        //       ? `${e.request.destination.province.name}/${e.request.destination.name}`
        //       : " - ",
        // },
        {
          field: "request.tonnage",
          title: "تناژ",
          template: (e) =>
            e.request && e.request.tonnage ? `${e.request?.tonnage}` : " - ",
          width: "40px",
        },
        {
          field: "price",
          title: this.$currencyLabel("قیمت بر تناژ"),
          template: (e) =>
            e.price
              ? `${this.$thousandSeprator(
                  this.$round(e.price / e.request?.tonnage, 0)
                )}`
              : " - ",
          width: "100px",
        },
        {
          field: "net_price",
          title: this.$currencyLabel("قیمت صافی بر تناژ"),
          template: (e) =>
            e.net_price
              ? e.request?.tonnage
                ? this.$thousandSeprator(
                    this.$round(e.net_price / e.request?.tonnage, 0)
                  )
                : "تناژ آزاد"
              : " - ",
          width: "100px",
        },
        // {
        //   field: "request.loading_at",
        //   title: "تاریخ بارگیری",
        //   template: (e) =>
        //     e.request && e.request.loading_at
        //       ? `${this.$getJalaliDateFromDateTime(e.request.loading_at)}`
        //       : " - ",
        // },
        // {
        //   field: "request.delivery_at",
        //   title: "تاریخ تحویل",
        //   template: (e) =>
        //     e.request && e.request.delivery_at
        //       ? `${this.$getJalaliDateFromDateTime(e.request.delivery_at)}`
        //       : " - ",
        // },
        {
          field: "parent_item",
          title: "راننده",
          template: (e) =>
            e.request_ticket_detail
              ? `${e.request_ticket_detail?.name}`
              : " - ",
          width: "100px",
        },
        // {
        //   field: "carrier",
        //   title: "باربری",
        //   template: (e) => (e.carrier ? `${e.carrier.name}` : " - "),
        // },
        {
          field: "customer",
          title: "کد ملی",
          template: (e) =>
            e.request_ticket_detail
              ? `${e.request_ticket_detail?.national_code}`
              : " - ",
          width: "100px",
        },
        {
          field: "attend_time",
          title: "هوشمند ماشین",
          template: (e) =>
            e.request_ticket_detail
              ? `${e.request_ticket_detail?.car_smartnumber}`
              : " - ",
          width: "100px",
        },
        {
          field: "attend_time",
          title: "شماره پلاک",
          template: (e) =>
            e.request_ticket_detail
              ? `${e.request_ticket_detail?.number_plate}`
              : " - ",
          width: "100px",
        },
        {
          field: "attend_time",
          title: "شماره تماس",
          template: (e) =>
            e.request_ticket_detail
              ? `${e.request_ticket_detail?.phone}`
              : " - ",
          width: "100px",
        },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : " - ",
          width: "100px",
        },
        {
          field: "updated_at",
          title: "آخرین بروزرسانی",
          template: (e) =>
            e.updated_at ? this.$getJalaliDateTime(e.updated_at) : " - ",
          width: "100px",
        },
        {
          field: "state",
          title: "وضعیت",
          template: (e) => (e.state ? e.state.name : " - "),
          width: "100px",
        },
        {
          title: "عملیات",
          command: [],
          width: 50,
        },
      ],
      states: [],
      pageSize: 30,
      currentPage: 1,
    };
  },
  computed: {
    filterTitle() {
      return this.showFilters ? "حذف فیلتر" : "اعمال فیلتر";
    },
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.loadData();
      },
    },
  },
  mounted() {
    this.isLoadingGrid = true;
    Promise.all([
      this.getRequests(),
      this.getCustomers(),
      // this.getCarriers(),
      this.getStates(),
      this.getDrivers(),
    ]).then((res) => {
      this.requests = res[0].data;
      this.customers = res[1].data;
      // this.carriers = res[2].data;
      this.states = res[3].data;
      this.drivers = res[4].data;
      this.isLoadingGrid = false;
    });
    this.loadData();
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
  },
  methods: {
    showAssignRequestToDriverForm(requestDetail) {
      this.$refs.assignRequestToDriver.init({ requestDetail });

      this.$toggleModal("#assign-request-to-driver-modal");
    },
    showDriverInfo(requestDetail) {
      this.$refs.driverInfo.init({ requestDetail });

      this.$toggleModal("#driver-info-modal");
    },
    waybillInfo(requestDetail) {
      this.$refs.waybillInfo.init({ requestDetail });

      this.$toggleModal("#waybill-info-modal");
    },
    resetFilters() {
      let dropDowns = ["driverDropDown", "statesDropDown", "carrierDropDown"];
      for (let ref of dropDowns) {
        if (this.$refs[ref]) this.$refs[ref].emptyKendo();
      }
      this.$refs.form.reset();
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;
      if (!this.showFilters) {
        this.filter = {};
        this.resetFilters();
        this.loadData();
      }
    },
    // getCarriers() {
    //   return this.$persistClient("get", "carriers");
    // },
    getStates() {
      return this.$persistClient("get", "states?type=requestdetail");
    },
    onDataBinding: function(ev) {
      var vm = this;
      setTimeout(() => {
        var grid = $("#grid").data("kendoGrid");
        var items = ev.items;
        items.forEach(function(item) {
          var dataItem = item;
          var selector = $(`.k-master-row[data-uid=${item.uid}]`);
          if (dataItem.state.color && !vm.filter.state_id) {
            selector.css("background-color", `#${dataItem.state.color}`);
            selector.css("color", `${vm.$findBgColor(dataItem.state.color)}`);
          }
        });
      }, 1000);
      this.record =
        (this.gpage - 1) * this.$refs.grid.$refs.datasource.pageSize;
      var grid = this.$refs.grid.$refs.grid.kendoWidget();
      // this.report.review == 2 ? grid.hideColumn(10) : "";
    },
    getTemplateID() {
      return this.$refs.grid.getTemplateLocal();
    },
    readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.$resetGrid();
      this.isLoadingGrid = true;
      let url = this.$makeQueryStringForSpatie(
        `request-details?sort=-updated_at&filter[request_id]=${this.$route.params.id}&include=state,request&page=${this.currentPage}&page_size=${this.pageSize}`,
        this.filter,
        "&"
      );
      this.$persistClient("get", url)
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData: _.debounce(function() {
      this.$refs.grid.loadDataSource();
    }, 1000),
    statusChangeModalEdit() {
      this.$toggleModal("#edit-modal");
    },
    printRequestDetail() {
      const q = { request_id: this.$route.params.id };

      this.$print("reports/export-rd2", q);
    },
    printRequestDetailSummary() {
      const q = { request_id: this.$route.params.id };

      this.$print("reports/export-rd3", q);
    },
    showGallery() {
      this.$refs.inputExcelRef.click();
    },
    sendExcel(event) {
      const files = event.target.files;

      if (!files && files <= 0) return;

      const formData = this.$getFormData({
        file: files[0],
      });

      this.$persistClient(
        "post",
        `requests/${this.$route.params.id}/import`,
        formData
      )
        .then((res) => {
          this.$izitoast("success", "اکسل با موفقیت ارسال شد", "موفق");

          this.loadData();
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    gridCommands() {
      return [
        {
          text: "view",
          click: this.showActions,
          template:
            "<a role='button' class='k-button k-button-icontext k-grid-view'><span class='fas fa-ellipsis-v' style='color:rgb(20 169 217)'></span></a>",
        },
      ];
    },
    showActions(e) {
      e.originalEvent.stopPropagation();

      const request = this.$refs.grid.getSelectedGridRow(e);

      this.$refs.contextMenu.init(e.originalEvent, request);
    },
    edit(requestDetail) {
      this.updateForm = {
        id: requestDetail.id,
      };

      this.statusChangeModalEdit();
    },
    deleteRequest(requestDetail) {
      this.$alert(
        "question",
        `آیا از حذف ${requestDetail.tracking_code} اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `request-details/${requestDetail.id}`)
            .then((res) => {
              this.$izitoast("success", "با موفقیت حذف شد", "موفق");
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    getRequests() {
      return this.$persistClient("get", `requests/${this.$route.params.id}`);
    },
    getDrivers(search = "") {
      return this.$persistClient(
        "get",
        `drivers/paginate?filter[search]=${search}`
      );
    },
    getCustomers() {
      return this.$persistClient("get", "customers");
    },
    filterDrivers(e) {
      this.getDrivers(e.filter.value).then((res) => {
        this.drivers = res.data;
      });
    },
    driverSearch: _.debounce(function() {
      this.loadData();
    }, 1000),
    handleEdit(data) {
      this.isLoadingModal = true;

      this.$persistClient("patch", `request-details/${data.id}/states`, data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);

          this.updateForm = {
            state_id: 0,
          };

          this.loadData();
          this.$refs.editModal.reset();

          this.statusChangeModalEdit();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
  },
};
</script>
<style scoped>
.fade-enter-active {
  transition: opacity 0.5s;
  animation: fade-in 0.5s;
}

.fade-leave-active {
  transition: opacity 0.5s;
  animation: fade-in 0.5s reverse;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.font-bold.main-card__data {
  font-size: 20px !important;
}
@keyframes fade-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
</style>
